// extracted by mini-css-extract-plugin
export default {"star":"star-rating_star__lP7m3","starSpan":"star-rating_starSpan__zXIqh"};